import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DownloadService } from 'src/app/argic/services/download.service';
import { LoginService } from 'src/app/login/login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-technicalcommittee',
  templateUrl: './technicalcommittee.component.html',
  styleUrls: ['./technicalcommittee.component.scss'],
  providers: [MessageService]
})
export class TechnicalcommitteeComponent implements OnInit {
    infoDownloads$:Observable<any>;
    Files: any[]=[];
    sections$:BehaviorSubject<any> = new BehaviorSubject(null);

    public downloadPath:string="";
    constructor(private downloadService: DownloadService, public loginService: LoginService,  private httpService: HttpClient, private messageService: MessageService) { }

    public doDownload(str)
    {
        window.location.href="/Download/GetTechFile?filename="+encodeURI(str);
    }

    ngOnInit(): void {
        this.downloadPath = environment.assetsInfo;
        this.loadData();

        this.infoDownloads$.subscribe(data => {
            let sects = data.map(x => x.section);
            sects = sects.filter((x, i, a) => a.indexOf(x) == i).map(x => { return { name:x, value:x};});
            this.sections$.next(sects);
        });
    }

    private loadData() {
        this.infoDownloads$ =
            this.downloadService.getAllTech().pipe(
                map((data) => {
                    let arr: any = [];
                    for (let x of data) {
                        if (arr.some(e => e.section == x.Section)) {
                            arr.find(e => e.section == x.Section).downloads.push(x);
                        } else {
                            let dl = [];
                            dl.push(x);
                            arr.push({
                                downloads: dl,
                                section: x.Section
                            });
                        }
                    }
                    return arr;
                }
                )
            );
    }

    uploadFiles (uploader: any, section:Dropdown) {
        const frmData = new FormData();

        frmData.append("Form","upload_form");
        frmData.append("Section",section.selectedOption.value);

        this.Files = uploader.files;

        for (var i = 0; i < this.Files.length; i++) {
          frmData.append("Files", this.Files[i]);
        }

        this.httpService.post(environment.localUrl+'Upload/UploadTech', frmData, { withCredentials:true}).subscribe(
          data => {
            this.messageService.add({
                     key: "Submitted",
                     severity: "info",
                     summary: "Submitted",
                     detail: "Upload finished.",
                 });
               this.loadData();
          },
          (err: HttpErrorResponse) => {
            console.log (err.message);
          }
        );
      }

      deleteFile(filename:string) {
        const frmData = new FormData();

        frmData.append("Form","upload_form_delete");
        frmData.append("Filename",filename);

        this.httpService.post(environment.localUrl+'Upload/DeleteTech', frmData, { withCredentials:true}).subscribe(
          data => {
            this.messageService.add({
                     key: "Deleted",
                     severity: "info",
                     summary: "Deleted",
                     detail: "Delete finished.",
                 });


                 //reload data:
                this.loadData();

          },
          (err: HttpErrorResponse) => {
            console.log (err.message);
          }
        );
      }

}
